/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Mod7_BodyInputs */

const es_landing_mod7_body = /** @type {(inputs: Landing_Mod7_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La modalidad que solo Zarpar puede ofrecerte como gestora autorizada.`)
};

const gl_landing_mod7_body = /** @type {(inputs: Landing_Mod7_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A modalidade que só Zarpar pode ofrecerche como xestora autorizada.`)
};

const en_landing_mod7_body = /** @type {(inputs: Landing_Mod7_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The option only Zarpar can offer you as an authorised manager.`)
};

/**
* | output |
* | --- |
* | "The option only Zarpar can offer you as an authorised manager." |
*
* @param {Landing_Mod7_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_mod7_body = /** @type {((inputs?: Landing_Mod7_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Mod7_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_mod7_body(inputs)
	if (locale === "en") return en_landing_mod7_body(inputs)
	return es_landing_mod7_body(inputs)
});